import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const investors = [
  {
    icon: 'dhl-icon',
    title: 'Alberto Oltra',
    subtitle: 'Latam CEO DHL Global Forwarding',
    img: 'dhl',
  },
  { icon: 'kaufmann-icon', title: 'Alexander Köhler', subtitle: 'CEO Kaufmann', img: 'kaufmann1' },
  { icon: 'redbus-icon', title: 'Prakash Sangam', subtitle: 'CEO redbus', img: 'redbus' },
  {
    icon: 'chilefilms-icon',
    title: 'Jose Patricio Daire',
    subtitle: 'CF Inversiones',
    img: 'chilefilms',
  },
  { icon: '', title: '', subtitle: '', img: '' },
  { icon: 'kaufmann-icon1', title: 'Rodrigo Gomez', subtitle: 'CFO Kaufmann', img: 'kaufmann1' },
  { icon: 'bsvv-icon', title: 'Jorge Vigil', subtitle: 'Barros Silva Varela Vigil', img: 'bsvv' },
  { icon: '', title: '', subtitle: '', img: '' },
];

const companies = [
  {
    icon: 'kaufmann',
    title: 'Kaufmann',
    web: 'https://www.kaufmann.cl/',
    details:
      'Kaufmann es una empresa líder en el mercado automotriz; automóviles y vehículos comerciales, con sucursales en todo Chile. Arribaron a Chile desde Alemania en el año 1950 para iniciar los respectivos estudios de mercado, con el propósito de llevar a cabo la representación para Daimler-Benz AG.',
  },
  {
    icon: 'makemytrip',
    title: 'Make my trip',
    web: 'https://www.makemytrip.com/',
    details:
      'MakeMyTrip es una compañía india de viajes en línea fundada en el año 2000. Con sede en Gurugram, Haryana, la compañía brinda servicios de viajes en línea que incluyen boletos de avión, paquetes de vacaciones nacionales e internacionales, reservas de hotel, boletos de tren y autobús.',
  },
  {
    icon: 'imaginelab',
    title: 'Imagine lab',
    web: 'https://grupo-imagine.com/',
    details:
      'Imagine Lab es una aceleradora de negocios tecnológicos que, desde el 2014, apoya el crecimiento de startups de alto impacto a través de financiamiento, mentoría, asesoría directiva, redes comerciales, entre otras, y también trabaja con el mundo corporativo y público en estrategias de corporate venturing.',
  },
  {
    icon: 'corfo',
    title: 'Corfo',
    web: 'https://www.corfo.cl',
    details:
      'CORFO es un servicio público descentralizado, cuyo equipo trabaja a lo largo de todo Chile, apoyando el emprendimiento, la innovación y la competitividad, teniendo como principal objetivo promover una sociedad de más y mejores oportunidades para contribuir al desarrollo económico del país.',
  },
];

class OurInvestors extends Component {
  static propTypes = {
    pages: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="investors-default-page pages-investors">
        <div className="home-banner" style={{ marginBottom: 70 }}>
          <img src="/static/images/icons/investors/investors-banner.png" alt="home-banner" />
        </div>
        <div className="page-title font20 white-text">
          {i18next.language == 'es' ? (
            <span>
              Nuestros<span className="bold-text">&nbsp;inversionistas</span> <br />
              <span className="font10">Entidades que nos brindan su apoyo</span>
            </span>
          ) : (
            <span>
              Our<span className="bold-text">&nbsp;Investors</span> <br />
              <span className="font10">Entities that support us</span>
            </span>
          )}
        </div>
        <div className="content-container font10">
          <div className="home-banner-container" style={{ flexDirection: 'row' }}>
            {companies.map((val, key) => (
              <div className="investors-item" key={key}>
                <img src={'/static/images/icons/investors/' + val.icon + '.png'} alt={val.title} />
              </div>
            ))}
          </div>
          <div className="home-banner-container" style={{ flexDirection: 'row' }}>
            {companies.map((val, key) => (
              <div className="center-text" key={key}>
                <span className="font12 bold-text primary-text">{val.title}</span>
                <div className="bus-companies font10" style={{ paddingLeft: 15, paddingRight: 15 }}>
                  {val.details}
                  <div>
                    <a className="bus-companies-select-more float-right">
                      <span>
                        <img
                          src="/static/images/icons/home/icon-right-arrow-bold.png"
                          alt={this.props.t('TRANSLATIONS.ICON_RIGHT3')}
                        />
                        &nbsp;
                      </span>

                      <a href={val.web} target="_blank">
                        <span className="destination-routes-more-option bold-text primary-text">
                          {this.props.t('TRANSLATIONS.VISIT_WEB')}
                        </span>
                      </a>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div
            className="flex-row contact-us-item investors-rows"
            style={{ paddingLeft: 0, paddingRight: 0, flexWrap: 'wrap' }}
          >
            {investors.map((val, key) => (
              <div className="investor-item center-text" key={key}>
                <img src={'/static/images/icons/investors/' + val.icon + '.png'} alt={val.title} />
                <div style={{ marginTop: 10 }}>
                  <span className="bold-text">{val.title}</span> <br />
                  {val.subtitle}
                </div>
                <div className="brand">
                  <img
                    style={val.img === 'redbus' ? { maxWidth: 70 } : { maxWidth: 89 }}
                    src={'/static/images/icons/investors/' + val.img + '.png'}
                    alt={val.img}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(OurInvestors);



// WEBPACK FOOTER //
// ./src/features/pages/OurInvestors.js